import React, { PropsWithChildren } from 'react';
import { Button, Icon, Text } from 'view/atoms';
import * as S from './PopupConfirm.styles';
import { ModalWindow } from '../ModalWindow';

type Props = PropsWithChildren<{
  closeHandler: (e: React.MouseEvent) => void;
  confirmHandler: (e: React.MouseEvent) => void;
  title: string;
  description?: string;
  yesButtonSrcIcon?: string;
  yesText: string;
  cancelText: string;
  areButtonsHorizontal?: boolean;
  isDisabledConfirm?: boolean;
  modalRef?: React.Ref<HTMLDivElement>;
  'data-testid'?: string;
  confirmButtonTestId?: string;
}>;

export const PopupConfirm = ({
  closeHandler,
  confirmHandler,
  title,
  description,
  yesButtonSrcIcon,
  yesText,
  cancelText,
  children,
  areButtonsHorizontal,
  isDisabledConfirm,
  modalRef,
  'data-testid': dataTestId,
  confirmButtonTestId,
}: Props) => {
  return (
    <ModalWindow
      ref={modalRef}
      hideWindow={closeHandler}
      contentStyles={S.ModalStyle}
      data-testid={dataTestId}
    >
      <S.TitleWrapper>
        <Text kind='h2'>{title}</Text>
        {description && <Text kind='body'>{description}</Text>}
      </S.TitleWrapper>

      {children}

      <S.ButtonWrapper areButtonsHorizontal={areButtonsHorizontal}>
        <Button
          type='button'
          kind='primary'
          onClick={confirmHandler}
          disabled={isDisabledConfirm}
          data-testid={confirmButtonTestId}
        >
          {yesButtonSrcIcon && <Icon src={yesButtonSrcIcon} alt='location' />}
          <Text kind='button' color={isDisabledConfirm ? 'gray2' : 'gray1'}>
            {yesText}
          </Text>
        </Button>

        <Button type='button' kind='secondary' onClick={closeHandler}>
          {cancelText}
        </Button>
      </S.ButtonWrapper>
    </ModalWindow>
  );
};
